import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/@shared';
import { NotificationsModule, OffersModule } from 'pr1-ui-components';
import { StandardV1RoutingModule } from './standard.v1.routing.module';
import {
  ProductBrandComponent,
  ProductBrandsComponent,
  ProductBrandListTableComponent,
  DivisionComponent,
  DivisionListTableComponent,
  DivisionsComponent,
  EventComponent,
  EventDetailsComponent,
  EventListExpansionPanelComponent,
  EventListTableComponent,
  EventTypesComponent,
  EventTypeComponent,
  EventWorkflowComponent,
  EventsComponent,
  OfferComponent,
  OfferListCardsComponent,
  OfferListTableComponent,
  OfferDetailsComponent,
  OfferPricingFormComponent,
  OffersComponent,
  OfferTagsComponent,
  OfferTagComponent,
  StoresComponent,
  StoreComponent,
  UsersComponent,
  UserComponent,
  VersionComponent,
  VersionListComponent,
  VersionDetailsComponent,
  ProductCategoriesComponent,
  ProductCategoryComponent,
  ProductCategoryListTableComponent,
  ProductListTableComponent,
  ProductComponent,
  ProductsComponent,
  VersionStoreListComponent,
  VersionStoreDialogComponent,
  OfferVersionsComponent,
  OfferProductsComponent,
  OfferAssetsComponent,
  OfferActivityLogComponent,
  OfferAddVersionsComponent,
  OfferProductsCardsComponent,
  OfferProductsTableComponent,
  OfferAddProductsComponent,
  AssetListCardsComponent,
  AssetListTableComponent,
  AssetsComponent,
  UploadAssetsComponent,
  UploadAssetsProductsComponent,
  UploadAssetsOffersComponent,
  UploadAssetsEventsComponent,
  AssetsEditDetailsComponent,
  ProductAssetListComponent,
  ProductTabsComponent,
  OfferProductUpdateRankComponent,
  OfferPromoSortDialogComponent,
  PromoAssetsComponent,
  PromoDetailsComponent,
  PromoAddVersionsComponent,
  PromoVersionsComponent,
  UploadAssetsPromosComponent,
  UploadAssetsOfferGroupsComponent,
  UploadAssetsProductBrandsComponent,
  PromoActivityLogComponent,
  ProductBrandTabsComponent,
  ProductBrandAssetListComponent,
  EventAssetListComponent,
  VersionAssetListComponent,
  VendorsComponent,
  VendorComponent,
  CloneEventComponent,
  CloneOfferComponent,
  VersionOfferCardsComponent,
  VersionOffersComponent,
  VersionOfferTableComponent,
  VersionPromosComponent,
  VersionPromoCardsComponent,
  VersionPromoTableComponent,
  AddWorkflowComponent,
  EditWorkflowComponent,
  UsersTableComponent,
  AddWorkflowUsersComponent,
  ShoppersComponent,
  ShopperDetailsComponent,
  ShopperComponent,
  ShoppingStatsComponent,
  AddUserOrganizationDetailsComponent,
  WorkflowManagementComponent,
  AdminAddWorkflowComponent,
  AdminAddWorkflowUsersComponent,
  AdminEditWorkflowComponent,
  AddGroupDialogComponent,
  WorkflowUsersTableComponent,
  AdminUsersTableComponent,
  UploadAssetsVersionsComponent,
  EditOfferTagsComponent,
  OfferGroupComponent,
  OfferGroupVersionsComponent,
  OfferGroupTagsComponent,
  OfferGroupEditComponent,
  OfferGroupDetailsComponent,
  OfferGroupEditVersionsComponent,
  OfferGroupOffersComponent,
  OfferGroupAssetsComponent,
  OfferGroupAddVersionsComponent,
  OfferGroupOffersCardsComponent,
  OfferGroupOffersTableComponent,
  AssetsSearchDialogComponent,
  AssetsListComponent,
  AssetsRankDialogComponent,
  MontageEditorComponent,
  MontageImageLayersComponent,
  MontageAssetsListComponent,
  MontageHistoryDialogComponent,
  MontageHistoryPreviewComponent,
  SettingsComponent,
  AddAdminUserComponent,
  AdminIntegrationComponent,
  EditIntegrationDialogComponent,
  ManageProvidersDialogComponent,
  OfferGroupOffersSearchDialogComponent,
  OffergroupOfferRankDialogComponent,
  EditDatesDialogComponent,
  IACopyEditDialogComponent,
  IACopyFeedbackDialogComponent,
  VersionListDialogComponent,
  VersionManagementDialogComponent,
  AddAssetComponent,
  AssignPageComponent,
  EventAttributesListComponent,
  EventAssociatedAttributesListComponent,
  EditEventAssociatedAttributeDialogComponent,
  CreateEventAttributeComponent,
  ListViewShellComponent,
  EventsShellComponent,
  SelectedRecordsDialogComponent,
  NewMontageEditorComponent,
} from '.';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { CouponManagementComponent } from './pages/coupon-management/coupon.management.component';
import { CouponComponent } from './pages/coupon/coupon.component';
import { CouponDetailsComponent } from './components/coupon-details/coupon.details.component';
import { CouponsListCardsComponent } from './components/coupons-list-cards/coupons.list.cards.component';
import { CouponSortDialogComponent } from './components/coupon-sort-dialog/coupon.sort.dialog.component';
import { CouponProductsComponent } from './components/coupon-products/coupon.products.component';
import { CouponProductsTableComponent } from './components/coupon-products-table/coupon-products-table.component';
import { CouponProductsCardsComponent } from './components/coupon-products-cards/coupon-products-cards.component';
import { CouponProductUpdateRankComponent } from './components/coupon-product-update-rank/coupon-product-update-rank.component';
import { CouponAddProductsComponent } from './components/coupon-add-products/coupon-add-products.component';
import { CouponAssetsComponent } from './components/coupon-assets/coupon-assets.component';
import { CouponListTableComponent } from './components/coupon-list-table/coupon.list.table.component';
import { MaterialModule } from 'src/app/material.module';
import { BannersComponent } from './pages/banners/banners.component';
import { BannerListTableComponent } from './pages/banners/banner-list-table/banner-list-table.component';
import { BannerDetailsComponent } from './pages/banners/banner-details/banner-details.component';
import { CloneComponent } from './pages/clone/clone.component';
import { CloneOffersComponent } from './pages/clone-offers/clone-offers.component';
import { CloneOffersListTableComponent } from './pages/clone-offers-list-table/clone-offers-list-table.component';
import { EditPageComponent } from './components/edit-page/edit-page.component';
import { VersionsListComponent } from './components/versions-list/versions-list.component';
import { StoreSelectorDialogComponent } from './components/store-selector-dialog/store-selector-dialog.component';
import { VersionStoreSortDialogComponent } from './components/version-store-sort-dialog/version-store-sort-dialog.component';
import { UploadAssetDialogComponent } from './components/upload-asset-dialog/upload-asset-dialog.component';
import { EtlMonitorComponent } from './pages/etl-monitor/etl-monitor.component';
import { DataFeedMonitorComponent } from './pages/data-feed-monitor/data-feed-monitor.component';
import { DataFeedDetailsDialogComponent } from './pages/data-feed-monitor/data-feed-details-dialog/data-feed-details-dialog.component';
import { IACopyReportDialogComponent } from './pages/data-feed-monitor/ia-copy-report-dialog/ia-copy-report-dialog.component';
import { DataFeedTraceDialogComponent } from './pages/data-feed-monitor/data-feed-trace-dialog/data-feed-trace-dialog.component';
import { DataFeedConfirmDialogComponent } from './pages/data-feed-monitor/data-feed-confirm-dialog/data-feed-confirm-dialog.component';
import { DataFeedImportConfirmDialogComponent } from './pages/data-feed-monitor/data-feed-import-confirm-dialog/data-feed-import-confirm-dialog.component';
import { CustomFieldsListTableComponent } from './components/custom-fields/custom-fields-list-table/custom-fields-list-table.component';
import { CreateCustomFieldComponent } from './components/custom-fields/create-custom-field/create-custom-field.component';
import { DynamicFieldComponent } from './components/custom-fields/dynamic-field/dynamic-field.component';
import { DynamicFieldsSectionComponent } from './components/custom-fields/dynamic-fields-section/dynamic-fields-section.component';
import { PrintAttributesListTableComponent } from './components/print-attributes/print-attributes-list-table/print-attributes-list-table.component';
import { CreatePrintAttributeComponent } from './components/print-attributes/create-print-attribute/create-print-attribute.component';
import { CloneVersionsComponent } from './pages/clone-versions/clone-versions.component';
import { StoreAttributeTypesComponent } from './pages/store-attribute-types/store-attribute-types.component';
import { StoreAttributeSummaryCardsComponent } from './components/store-attribute-types/summary-cards/summary-cards.component';
import { StoreAttributeCategoryAccordionComponent } from './components/store-attribute-types/category-accordion/category-accordion.component';
import { StoreAttributeTypeRowComponent } from './components/store-attribute-types/attribute-type-row/attribute-type-row.component';
import { AddEditCategoryDialogComponent } from './components/store-attribute-types/dialogs/add-edit-category-dialog/add-edit-category-dialog.component';
import { AddEditAttributeTypeDialogComponent } from './components/store-attribute-types/dialogs/add-edit-attribute-type-dialog/add-edit-attribute-type-dialog.component';
import { ManageValuesDialogComponent } from './components/store-attribute-types/dialogs/manage-values-dialog/manage-values-dialog.component';
import { ManageCategoriesDialogComponent } from './components/store-attribute-types/dialogs/manage-categories-dialog/manage-categories-dialog.component';
import { StoreAttributesEditSectionComponent } from './components/store-attributes-edit-section/store-attributes-edit-section.component';
import { VersionAttributeSearchComponent } from './components/version-attribute-search/version-attribute-search.component';
import { VersionConflictDetailPanelComponent } from './components/version-conflict-detail-panel/version-conflict-detail-panel.component';
import { VersionEntityAssociationAttributeSearchComponent } from './components/version-entity-association-attribute-search/version-entity-association-attribute-search.component';
import { VersionEntityAssociationDialogComponent } from './components/version-entity-association-dialog/version-entity-association-dialog.component';
import { VersionSearchDialogComponent } from './components/version-search-dialog/version-search-dialog.component';

@NgModule({
  declarations: [
    ProductBrandComponent,
    ProductBrandsComponent,
    ProductBrandListTableComponent,
    DivisionComponent,
    DivisionListTableComponent,
    DivisionsComponent,
    EventComponent,
    EventDetailsComponent,
    EventListExpansionPanelComponent,
    EventListTableComponent,
    EventTypesComponent,
    EventTypeComponent,
    EventWorkflowComponent,
    AddWorkflowComponent,
    EditWorkflowComponent,
    UsersTableComponent,
    EventsComponent,
    EventsShellComponent,
    EventAssetListComponent,
    OfferComponent,
    OfferListCardsComponent,
    OfferListTableComponent,
    OfferDetailsComponent,
    OfferVersionsComponent,
    OffersComponent,
    AssetListCardsComponent,
    AssetListTableComponent,
    AssetsComponent,
    OfferTagsComponent,
    OfferTagComponent,
    StoresComponent,
    StoreComponent,
    UsersComponent,
    AddAdminUserComponent,
    SettingsComponent,
    UserComponent,
    AddUserOrganizationDetailsComponent,
    UploadAssetsComponent,
    UploadAssetsProductsComponent,
    UploadAssetsOffersComponent,
    UploadAssetsEventsComponent,
    UploadAssetsProductBrandsComponent,
    UploadAssetsPromosComponent,
    UploadAssetsOfferGroupsComponent,
    AssetsEditDetailsComponent,
    ProductTabsComponent,
    ProductAssetListComponent,
    VersionComponent,
    VersionListComponent,
    VersionDetailsComponent,
    VersionAssetListComponent,
    ProductCategoriesComponent,
    ProductCategoryComponent,
    ProductCategoryListTableComponent,
    ProductListTableComponent,
    ProductComponent,
    ProductsComponent,
    OfferProductsComponent,
    OfferProductsCardsComponent,
    OfferProductsTableComponent,
    OfferAssetsComponent,
    OfferActivityLogComponent,
    PromoActivityLogComponent,
    OfferAddProductsComponent,
    VersionStoreListComponent,
    VersionStoreDialogComponent,
    OfferAddVersionsComponent,
    OfferProductUpdateRankComponent,
    OfferPromoSortDialogComponent,
    PromoAssetsComponent,
    PromoDetailsComponent,
    PromoVersionsComponent,
    PromoAddVersionsComponent,
    ProductBrandTabsComponent,
    ProductBrandAssetListComponent,
    VendorsComponent,
    VendorComponent,
    CloneEventComponent,
    CloneOfferComponent,
    VersionOfferCardsComponent,
    VersionOfferTableComponent,
    VersionOffersComponent,
    VersionPromosComponent,
    VersionPromoCardsComponent,
    VersionPromoTableComponent,
    CouponManagementComponent,
    CouponComponent,
    CouponDetailsComponent,
    CouponsListCardsComponent,
    CouponSortDialogComponent,
    CouponProductsComponent,
    CouponProductsCardsComponent,
    CouponProductsTableComponent,
    CouponProductUpdateRankComponent,
    CouponAddProductsComponent,
    CouponAssetsComponent,
    CouponListTableComponent,
    ShoppersComponent,
    ShopperDetailsComponent,
    ShopperComponent,
    ShoppingStatsComponent,
    AddWorkflowUsersComponent,
    WorkflowManagementComponent,
    AdminAddWorkflowComponent,
    AdminAddWorkflowUsersComponent,
    AdminEditWorkflowComponent,
    AddGroupDialogComponent,
    WorkflowUsersTableComponent,
    AdminUsersTableComponent,
    UploadAssetsVersionsComponent,
    EditOfferTagsComponent,
    BannersComponent,
    BannerListTableComponent,
    BannerDetailsComponent,
    CloneComponent,
    CloneOffersComponent,
    CloneOffersListTableComponent,
    OfferGroupComponent,
    OfferGroupVersionsComponent,
    OfferGroupTagsComponent,
    OfferGroupEditComponent,
    OfferGroupDetailsComponent,
    OfferGroupEditVersionsComponent,
    OfferGroupOffersComponent,
    OfferGroupAssetsComponent,
    OfferGroupAddVersionsComponent,
    OfferGroupOffersCardsComponent,
    OfferGroupOffersTableComponent,
    AssetsSearchDialogComponent,
    AssetsListComponent,
    AssetsRankDialogComponent,
    MontageEditorComponent,
    MontageImageLayersComponent,
    MontageAssetsListComponent,
    MontageHistoryDialogComponent,
    MontageHistoryPreviewComponent,
    AdminIntegrationComponent,
    EditIntegrationDialogComponent,
    ManageProvidersDialogComponent,
    OfferGroupOffersSearchDialogComponent,
    OffergroupOfferRankDialogComponent,
    EditDatesDialogComponent,
    IACopyEditDialogComponent,
  IACopyFeedbackDialogComponent,
    EditPageComponent,
    VersionsListComponent,
    StoreSelectorDialogComponent,
    VersionStoreSortDialogComponent,
    VersionListDialogComponent,
    VersionManagementDialogComponent,
    UploadAssetDialogComponent,
    EtlMonitorComponent,
    DataFeedMonitorComponent,
    DataFeedDetailsDialogComponent,
    IACopyReportDialogComponent,
    DataFeedTraceDialogComponent,
    DataFeedConfirmDialogComponent,
    DataFeedImportConfirmDialogComponent,
    CustomFieldsListTableComponent,
    CreateCustomFieldComponent,
    DynamicFieldComponent,
    DynamicFieldsSectionComponent,
    PrintAttributesListTableComponent,
    CreatePrintAttributeComponent,
    EventAttributesListComponent,
    EventAssociatedAttributesListComponent,
    EditEventAssociatedAttributeDialogComponent,
    CreateEventAttributeComponent,
    AssignPageComponent,
    OfferPricingFormComponent,
    AddAssetComponent,
    CloneVersionsComponent,
    ListViewShellComponent,
    SelectedRecordsDialogComponent,
    NewMontageEditorComponent,
    StoreAttributeTypesComponent,
    StoreAttributeSummaryCardsComponent,
    StoreAttributeCategoryAccordionComponent,
    StoreAttributeTypeRowComponent,
    AddEditCategoryDialogComponent,
    AddEditAttributeTypeDialogComponent,
    ManageValuesDialogComponent,
    ManageCategoriesDialogComponent,
    StoreAttributesEditSectionComponent,
    VersionAttributeSearchComponent,
    VersionConflictDetailPanelComponent,
    VersionEntityAssociationAttributeSearchComponent,
    VersionEntityAssociationDialogComponent,
    VersionSearchDialogComponent,
  ],
  imports: [
    StandardV1RoutingModule,
    NotificationsModule,
    OffersModule,
    SharedModule,
    FormsModule,
    DragDropModule,
    MaterialModule,
  ],
})
export class StandardV1Module { }
